import React from 'react';
import { v4 } from 'uuid';

/**
 * `useMemoizedUuid` returns a memoized Uuid that does not change over time
 * @returns string
 */
export const useMemoizedUuid = (): string => React.useMemo(() => v4(), []);
